import { render, staticRenderFns } from "./RunConfigTypeButton.vue?vue&type=template&id=b0fe7b18&"
import script from "./RunConfigTypeButton.vue?vue&type=script&lang=js&"
export * from "./RunConfigTypeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
